import * as styles from "./Heading.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";
import { TruncateMiddle } from "@frontend/components/atoms/TruncateMiddle";

import type { HeadingProps } from "./Heading.types";

export function Heading({
  name,
  suffix,
  href,
  icon,
  size,
  className,
}: HeadingProps): JSX.Element {
  const sizeClassName = size && styles.size[size];

  const content = (
    <>
      {icon && <Icon name={icon} className={styles.icon} />}
      <TruncateMiddle text={name} />
      {suffix !== undefined && suffix !== "" && (
        <span className={styles.suffix}>({suffix})</span>
      )}
    </>
  );

  return href ? (
    <a
      data-slot="heading"
      href={href}
      className={clsx(styles.link, sizeClassName, className)}
    >
      {content}
    </a>
  ) : (
    <strong
      data-slot="heading"
      className={clsx(styles.name, sizeClassName, className)}
    >
      {content}
    </strong>
  );
}
